export const BODY_THEME_RED_LUCKY_STRIKE = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

        
{/*Body*/} 

    {/*Two*/}
    <polygon 
        fill="rgb(255,255,255)" 
        points="60.552,329.4 92.127,396 655.779,396 655.779,275.4 642.933,250.745 608.1,230.634 436.5,209.563 86.8,185.109 76.176,203.256 76.193,275.4 60.568,275.4 60.552,329.4"
    />
    {/*One*/}
    <path 
        fill="rgb(230,230,230)" 
        d="M86.8,185.109l349.7,24.454l171.6,21.07l34.833,20.111v15.957 H612.34c-15.189-20.885-39.639-34.682-67.349-35.165c-23.848-0.417-45.626,9.108-61.376,24.737 c-26.417-13.027-57.538-16.255-83.05-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-13.847-10.339-30.925-16.596-49.456-16.92c-32.641-0.569-61.421,17.41-76.258,44.186H76.176v-72.144L86.8,185.109L86.8,185.109z"
    />
    
    {/*Three*/}
    <polygon 
        fill="rgb(230,230,230)" 
        points="92.127,396 642.933,396 642.933,298.921 227.025,275.4 60.568,275.4 60.552,329.4 92.127,396"
    />
    
    {/*Rear Bumper*/}
    <polygon 
        fill="rgb(210,210,210)" 
        points="76.176,329.4 92.127,396 179.855,396 179.855,329.4 76.176,329.4"
    />
    {/*Rear Bumper Highlight*/}
    <polygon 
        fill="rgb(255,255,255)" 
        points="76.176,285.279 60.552,285.279 60.568,275.4 76.176,275.4 76.176,285.279"
    />
    {/*Rear Bumper Shadow*/}
    <polygon 
        fill="rgb(190,190,190)" 
        points="60.552,329.4 76.176,329.4 92.127,396 60.552,329.4"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(190,190,190)" 
        d="M642.933,379.3V396H92.127l-0.001-0.002L92.127,396l0,0l-4-16.7 C283.727,379.3,447.309,379.3,642.933,379.3L642.933,379.3z"
    />
    
    {/*Inset Highlight*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v41.717l280.313-0.024C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />
    {/*Inset Shadow*/}
    <path 
        fill="rgb(130,130,130)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v12.312l251.604,10.985c10.855,0.475,22.532,9.438,26.881,16.582c0.765,1.256,1.308,1.813,1.828,1.813 C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />  
    
    {/*One Highlight*/}
    <polygon 
        fill="rgb(255,255,255)" 
        points="436.5,209.563 86.8,185.109 76.176,203.256 77.452,203.257 436.5,209.563"
    />
        

{/*Lucky Strike Theme Red Front*/}

    {/*Two*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M456.096,396h199.684V275.4l-12.847-24.656l-34.834-20.11	L468.14,213.449c13.222,17.158,22.609,37.625,26.614,60.337C502.892,319.938,486.992,364.952,456.096,396L456.096,396z"
    />
    {/*One*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M468.14,213.449l139.959,17.185l34.834,20.11v15.958h-30.592 c-15.19-20.884-39.64-34.682-67.35-35.165c-21.296-0.373-40.942,7.184-56.118,19.935	C483.932,237.559,476.872,224.782,468.14,213.449L468.14,213.449z"
    />
    {/*One Front Bumper*/}   
    <polygon 
        fill="rgb(210,0,0)" 
        points="655.779,275.399 642.933,250.744 608.099,230.634 642.933,285.278 642.933,298.921 655.779,298.921 655.779,275.399 	"
    />
    {/*Three*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M456.096,396h186.837v-97.079l-146.258-8.271 C498.774,330.743,483.212,368.751,456.096,396L456.096,396z"
    />
    {/*Three Front Bumper*/}
    <polygon 
        fill="rgb(180,0,0)" 
        points="655.779,379.3 655.779,298.921 642.933,298.921 642.933,379.3 655.779,379.3 	"
    />
    {/*Vent Background*/}
    <path 
        fill="rgb(220,0,0)" 
        d="M629.269,348.577l18.681,4.628l2.489-0.004 c1.779-0.004,3.422-0.325,3.422-2.821l-0.001-29.823c0-1.021-0.404-1.261-0.984-1.281l-21.414-0.759 c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603C625.877,344.809,626.697,347.94,629.269,348.577L629.269,348.577z"
    />
    {/*Vent*/}
    <path 
        fill="rgb(160,0,0)" 
        d="M648.527,353.204l-9.437-5.126c-1.72-0.934-2.519-2.618-2.52-4.77 l-0.005-11.837c0-2.773,0.814-4.013,2.066-4.716l13.386-7.511l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603 c0,2.714,0.82,5.846,3.392,6.482l18.681,4.628L648.527,353.204L648.527,353.204z"
    />
    {/*Vent Shadow*/}
    <path 
        fill="rgb(100,0,0)" 
        d="M628.042,324.644c-0.001-2.038,1.858-2.907,3.285-3.068 l20.691-2.33l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603c0,2.714,0.82,5.846,3.392,6.482 c-0.957-1.553-1.22-4.483-1.221-5.71L628.042,324.644L628.042,324.644z"
    />
    {/*Vent Highlight*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M632.043,348.424l12.192,3.385l-7.12-4.247 c-6.029-3.596-8.149-15.236-8.107-8.605C629.051,345.587,629.347,347.676,632.043,348.424L632.043,348.424z"
    />
    
    {/*Rocker*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M642.933,379.3V396H456.096c5.17-5.195,9.918-10.783,14.205-16.7 C526.066,379.3,582.994,379.3,642.933,379.3L642.933,379.3z"
    />
    {/*Rocker Front*/}
    <polygon 
        fill="rgb(125,0,0)" 
        points="642.933,379.3 642.933,396 655.779,396 655.779,379.3 642.933,379.3 	"
    />
      
    {/*Front Lip Highlight*/}
    <polygon 
        fill="rgb(255,0,0)" 
        points="543.528,365.473 655.779,365.473 655.779,364.026 642.933,362.38 633.41,364.026 543.528,364.026 543.528,365.473 	"
    />

{/*Lucky Strike Circle*/}
    
    {/*Black*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M470.685,396c28.623-32.987,42.752-78.034,34.634-124.076 c-3.687-20.905-11.606-40.041-22.712-56.699l-46.106-5.661l-189.268-13.235c-30.769,33.277-46.26,79.97-37.83,127.773 c4.865,27.59,17.119,52.109,34.368,71.898H470.685L470.685,396z"
    />
    {/*Gold Two*/}   
    <path 
        fill="rgb(196,188,142)" 
        d="M456.096,396c30.896-31.048,46.796-76.062,38.658-122.214 c-4.005-22.712-13.393-43.179-26.614-60.337l-31.64-3.886l-175.193-12.251c-32.653,31.137-49.711,77.449-41.339,124.926 c5.112,28.997,18.994,54.321,38.437,73.762H456.096L456.096,396z"
    />
    {/*Gold One*/}
    <path 
        fill="rgb(162,157,119)" 
        d="M488.873,251.473c-4.941-13.913-12.001-26.69-20.733-38.023 l-31.64-3.886l-183.846-3.229c-10.34,11.784-18.678,25.252-24.597,39.813c0.94,0.645,1.866,1.308,2.778,1.988 c16.449,12.037,4.027-19.916,22.414-18.791l147.315,9.01c25.512,1.666,56.633,4.894,83.049,17.921
		C485.3,254.603,487.054,253.001,488.873,251.473L488.873,251.473z"
    />
    {/*Gold Rocker*/}
    <path 
        fill="rgb(113,111,83)" 
        d="M456.096,396c5.17-5.195,9.917-10.783,14.204-16.7	c-75.993,0-149.825,0-226.155,0c4.321,5.955,9.094,11.535,14.26,16.7H456.096L456.096,396z"
    />
    {/*White Two*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M442.428,396c33.372-28.978,51.258-74.199,43.079-120.582 c-4.326-24.531-15.371-46.255-30.904-63.632l-18.103-2.223l-162.24-11.345c-34.646,28.897-53.399,75.015-45.045,122.391 c5.365,30.431,21.107,56.553,42.952,75.391H442.428L442.428,396z"
    />
    {/*White Three*/}
    <path 
        fill="rgb(210,210,210)" 
        d="M442.428,396c29.834-25.904,47.286-64.791,44.811-105.884	L229.25,275.525c-2.6,14.535-2.74,29.742-0.035,45.084c5.365,30.431,21.107,56.553,42.952,75.391H442.428L442.428,396z"
    />
    {/*White One*/}
    <path 
        fill="rgb(210,210,210)" 
        d="M480.013,254.572c-5.708-16.068-14.438-30.512-25.41-42.786 l-18.103-2.223l-171.322-3.009c-7.57,7.633-14.172,16.166-19.653,25.383c1.687-1.752,4.107-2.815,7.726-2.594l4.959,0.303 l-0.478-3.094c-0.937-6.063,5.249-6.133,8.186-5.914c2.12,0.156,18.931,1.012,28.843,5.051c5.166,2.104,7.236,4.842,8.14,6.69 l97.666,5.974C424.927,239.944,454.402,242.961,480.013,254.572L480.013,254.572z M242.795,236.758 c-2.451,4.547-4.635,9.242-6.537,14.063C241.135,251.397,240.594,243.198,242.795,236.758L242.795,236.758z"
    />
    {/*White Inset Highlight*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M459.483,351.795c-4.401-10.491-8.73-21.947-22.983-22.57 l-207.359-9.053c0.025,0.146,0.048,0.291,0.074,0.438c2.477,14.051,7.169,27.182,13.65,39.103h217.304 C461.342,359.712,461.205,355.898,459.483,351.795L459.483,351.795z"
    />
    {/*White Rocker*/}
    <path 
        fill="rgb(165,165,165)" 
        d="M442.428,396c5.864-5.092,11.248-10.687,16.098-16.7 c-67.944,0-134.343,0-202.557,0c4.904,6.054,10.33,11.64,16.198,16.7H442.428L442.428,396z"
    />
    {/*Red Two*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M427.189,396c36.713-26.151,57.315-71.879,49.018-118.938 c-4.718-26.755-18.032-49.899-36.602-67.117l-3.105-0.382l-147.994-10.349c-37.333,26.037-58.38,72.185-49.991,119.76 c5.694,32.296,23.97,59.346,48.917,77.025H427.189L427.189,396z"
    />
    {/*Red Three*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M427.189,396c33.446-23.824,53.517-63.896,50.55-106.421 l-238.995-13.517c-2.601,13.809-2.807,28.292-0.229,42.912c5.694,32.296,23.97,59.346,48.917,77.025H427.189L427.189,396z"
    />

    {/*Red One*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M467.98,249.808c-6.705-15.319-16.457-28.813-28.375-39.862 l-3.105-0.382l-157.75-2.771c-7.811,6.734-14.714,14.426-20.554,22.853l142.369,8.708	C421.188,239.7,445.475,242.068,467.98,249.808L467.98,249.808z"
    />
    {/*Red Rocker*/}
    <path 
        fill="rgb(121,0,0)" 
        d="M427.189,396c6.9-4.915,13.229-10.523,18.904-16.7	c-59.498,0-117.966,0-177.672,0c5.746,6.223,12.123,11.819,19.01,16.7H427.189L427.189,396z"
    />
    {/*Red Inset HL*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M459.483,351.795c-4.401-10.491-8.73-21.947-22.983-22.57 l-197.688-8.631c2.703,14.197,7.847,27.354,14.916,39.118h206.44C461.342,359.712,461.205,355.898,459.483,351.795L459.483,351.795
		z"
    />
    {/*Red Inset Shadow*/}
    <path 
        fill="rgb(100,0,0)" 
        d="M459.483,351.795c-4.401-10.491-8.73-21.947-22.983-22.57 l-197.688-8.631c0.809,4.245,1.836,8.396,3.066,12.445l189.581,8.277c10.855,0.474,22.532,9.438,26.881,16.582 c0.764,1.256,1.308,1.813,1.828,1.813C461.342,359.712,461.206,355.898,459.483,351.795L459.483,351.795z"
    />
    {/*Red Door HL*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M302.899,232.38c-0.903-1.849-2.974-4.587-8.14-6.69 c-9.912-4.039-26.723-4.895-28.843-5.051c-0.247-0.02-0.518-0.035-0.805-0.045c-2.443,2.902-4.745,5.921-6.905,9.037l0.002,0.016 L302.899,232.38L302.899,232.38z"
    />
    {/*Red Door Shadow*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M266.162,231.082c1.954,0,3.548,1.594,3.548,3.548	s-1.594,3.548-3.548,3.548c-1.953,0-3.547-1.594-3.547-3.548S264.209,231.082,266.162,231.082L266.162,231.082z M300.152,232.212 l-29.457-1.802c0.471,5.016,2.687,6.109,4.926,6.132l20.105,1.186C300.893,237.779,300.152,232.212,300.152,232.212 L300.152,232.212z"
    />
















    {/*Mirror Body Shadow*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M420.018,215.521l1.227,1.87 c-8.865-0.307-14.482,2.165-16.687,3.683c-2.327,1.602-2.546,5.234,3.085,4.68l25.139-2.47c1.26,0.041,2.572-0.003,3.807-0.202 c1.378-0.223,4.542-1.097,3.238-3.086l-2.383-3.635c-1.073,0.17-2.324,0.216-3.747,0.117 C429.137,216.16,424.577,215.84,420.018,215.521L420.018,215.521z"
    />
    {/*Mirror Background*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M437.443,216.361c4.697-0.74,6.028-3.823,3.786-7.244l-3.907-5.96 c-0.822-1.253-3.626-4.647-5.669-6.215c-6.813-5.228-12.349-6.552-21.103-6.552c-4.264,0-5.566,0.952-7.2,4.458 c-0.749,1.604-1.124,3.95-1.124,5.72v5.09c0,1.447,0.091,3.408,1.29,4.729l2.525,2.78c0.802,0.882,2.007,1.519,3.195,1.601 l10.78,0.754L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror Base*/}
    <path 
        fill="rgb(120,0,0)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-13.679-0.957L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror_Base_Highlight*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M438.299,219.592l-1.062-1.619
		c-0.336-0.513-1.093-0.805-1.733-0.85l-14.267-0.997l0.845,1.288l7.073,0.523c2.369,0.174,3.686,0.219,5.114,2.258
		c0.733,1.045,2.132,1.713,3.148,1.344C438.434,221.169,438.88,220.408,438.299,219.592L438.299,219.592z"
    />
    {/*"Mirror_Shadow"*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-24.459-1.711c-1.188-0.082-2.394-0.719-3.195-1.601l-2.525-2.78c-0.374-0.412-0.64-0.886-0.829-1.388	c6.532,0.457,33.813,2.364,38.542,0.118C443.472,212.538,442.141,215.621,437.443,216.361L437.443,216.361z"
    />
    {/*"Mirror_Highlight"*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M402.947,203.555c10.225,2.229,20.418-6.53,32.119-2.197 c-1.167-1.412-2.479-2.742-3.855-3.847c-3.146-2.373-6.389-4.21-10.196-5.287c-3.183-0.815-6.384-1.06-9.66-1.109	c-3.919-0.018-5.603,0.411-7.351,4.036c-0.744,1.691-1.035,3.584-1.057,5.423V203.555L402.947,203.555z"
    />

    

    

{/*Lucky Strike Logo*/}

    {/*Lucky Stirke Black*/}
    <path 
        fill="rgb(0,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.584,367.296l-3.116-18.661l4.915,1.926c3.758,1.478,7.353,2.025,10.98,1.676 l0.215-0.038c2.296-0.405,2.205-1.036,2.108-1.707c-0.23-1.409-1.997-2.033-5.968-3.105c-5.496-1.481-13.799-3.72-15.596-14.345 c-1.877-10.637,4.131-18.688,15.679-20.985c3.729-0.736,7.718-1.05,11.463-0.222l-0.131-0.791l60.532-10.674 c4.825-0.852,9.818,2.063,13.152,6.21l-1.46-8.382l35.796-6.42l1.994,11.311l3.377-12.244l48.263-8.306l2.783,15.783l-14.446,2.437 l0.491,2.782l12.623-2.226l2.611,14.805l-12.758,2.25l0.874,5.253l14.854-2.619l2.593,15.697l-46.717,8.335l-9.426-12.272
		l2.401,13.618l-50.368,8.679l-8.104-11.383l2.226,12.622l-18.2,3.21l-6.844-38.819l-5.461,1.029l6.819,38.674l-18.977,3.185	l-6.674-38.468l-5.447,1.024l1.251,6.723l-5.881-3.884c-3.123-2.063-6.313-2.43-8.256-2.088c-2.415,0.426-2.242,1.525-2.186,1.887 c0.124,0.769,2.949,1.447,5.015,1.944c5.868,1.408,14.735,3.538,16.694,15.084c1.498,9.293-3.77,19.875-16.736,22.161	C281.672,368.893,276.313,368.912,270.584,367.296L270.584,367.296z M370.989,342.031l-3.005-17.266 c-1.234,3.25-3.354,5.343-5.013,6.971L370.989,342.031L370.989,342.031z M426.192,327.302l-4.638-26.649l-4.189,14.873	L426.192,327.302L426.192,327.302z M346.9,322.488c1.046-0.262,2.193-0.646,2.787-1.163c0.251-0.215,0.769-0.664,0.418-2.657
		c-0.244-1.383-0.42-2.378-4.234-2.02L346.9,322.488L346.9,322.488z M314.533,305.077c-5.902,1.04-12.633,0.248-17.588-3.147	l0.963,5.462l-32.84,5.79l-9.643-54.691l19.146-3.376l6.896,38.489l9.189-1.619l-6.734-38.19l18.199-3.208l6.61,37.479 c0.454,1.004,2.085,1.116,3.113,0.935c0.958-0.169,2.352-0.768,2.479-1.749l-6.64-37.647l18.201-3.209l2.17,12.309 c2.466-9.052,9.095-15.17,19.038-16.924c4.541-0.801,8.394-0.793,11.743,0.021l-0.226-1.285l18.518-3.265l2.003,11.356 l3.371-12.314l28.003-4.812l7.697,10.374l2.447-12.278l19.695-3.474l-9.317,34.553l4.116,22.647l-18.427,3.248l-3.988-22.61 l-13.341-17.802l-4.019,14.863l21.061,25.49l-21.283,3.752l-11.086-13.06l2.604,14.776l-18.411,3.246l-0.314-1.786
		c-3.821,2.254-8.14,3.494-12.501,4.153c-9.646,1.477-17.459-1.784-22.463-8.977C331.738,296.881,324.588,303.305,314.533,305.077 L314.533,305.077z M353.168,258.01c-2.02,0.355-3.629,1.394-4.781,3.083c-1.672,2.446-2.27,6.177-1.554,9.735 c0.53,2.55,2.815,10.855,9.679,9.646c2.053-0.361,4.338-1.496,6.796-3.367l1.548-1.184l-2.899-16.45l-2.044-0.681 C357.351,257.936,355.082,257.672,353.168,258.01L353.168,258.01z"
    />
    {/*Lucky Strike White*/}
    <path 
        fill="rgb(255,255,255)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M292.592,315.354c-2.828-1.142-7.025-1.385-12.206-0.363 c-9.72,1.935-14.939,8.322-13.312,17.55c2.569,15.191,20.223,9.234,21.575,17.527c0.474,3.308-1.903,4.712-4.999,5.147 c-4.088,0.395-8.133-0.208-12.361-1.867l1.934,11.583c3.338,0.939,9.34,0.867,13.584,0.119 c11.795-1.971,15.707-11.412,14.523-18.75c-2.699-15.931-20.605-10.151-21.715-17.064c-0.903-5.746,7.992-7.423,15.047-2.762 L292.592,315.354L292.592,315.354z M294.568,313.477l1.635,9.884l9.316-1.754l6.684,38.529l13.068-2.195l-6.809-38.616l9.102-1.715 l-1.807-9.633L294.568,313.477L294.568,313.477z M366.82,300.626l8.44,48.501l13.153-2.32l-8.548-48.481L366.82,300.626 L366.82,300.626z M450.361,286.006l-27.476,4.845l8.386,48.181l27.707-4.776l-1.613-9.78l-14.854,2.619l-1.855-11.157l12.729-2.244	l-1.572-8.912l-12.622,2.226l-1.532-8.698l14.442-2.437L450.361,286.006L450.361,286.006z M421.214,290.816l-14.302,2.631 l-6.406,23.223l-3.778-21.427l-12.622,2.226l8.585,48.691l12.518-2.207l-4.003-22.7l15.76,20.52l14.428-2.543l-17.309-23.092 L421.214,290.816L421.214,290.816z M342.387,314.122l2.094,11.882c6.066-0.962,9.545-2.34,8.572-7.856 C352.21,313.373,348.752,312.999,342.387,314.122L342.387,314.122z M328.104,307.563l24.082-4.246 c5.286-1.042,12.305,5.267,13.428,11.633c1.938,10.378-3.703,13.123-6.593,16.583l13.857,17.795l-13.242,2.445l-11.485-16.135 l-2.334,0.412l3.143,17.821l-12.307,2.17L328.104,307.563L328.104,307.563z M272.153,258.579l-13.261,2.339l8.604,48.797	l26.943-4.751l-1.813-10.288l-13.578,2.394L272.153,258.579L272.153,258.579z M287.391,256.222l6.641,37.657 c6.121,14.236,34.363,10.021,36.07-6.36l-6.641-37.657l-12.307,2.17l6.172,35.009c0.088,5.452-9.797,7.086-11.492,1.807 l-6.137-34.795L287.391,256.222L287.391,256.222z M358.916,244.922c-3.464-1.03-7.376-0.889-11.3-0.195 c-15.276,2.692-19.3,15.872-17.048,29.258c2.271,13.492,10.258,22.802,24.424,20.633c4.58-0.697,8.621-1.958,12.16-4.223 l-2.032-10.908c-11.571,8.822-19.088,2.162-21.222-8.073c-1.82-9.084,3.248-20.042,16.963-15.459L358.916,244.922L358.916,244.922z M362.079,242.941l8.604,48.8l12.518-2.209l-4.003-22.702L396.32,287l14.533-2.563l-18.773-22.72l6.024-22.284l17.45,23.284 l3.591,20.367l12.52-2.207l-3.697-20.35l8.266-30.663l-13.048,2.301l-3.366,16.891l-10.617-14.313l-24.314,4.177l-6.388,23.329 l-3.797-21.532L362.079,242.941L362.079,242.941z"
    />
    {/*Lucky Strike Gray*/}
    <path 
        fill="rgb(200,200,200)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M450.721,335.678c-3.316-3.649-7.744-6.17-14.221-6.453 l-6.988-0.305l1.76,10.111L450.721,335.678L450.721,335.678z M423.468,328.656l-17.152-0.749l9.784,12.739l5.814,0.254l9.479-1.671	L423.468,328.656L423.468,328.656z M402.349,327.734l-13.007-0.568l2.188,12.407l13.007,0.568L402.349,327.734L402.349,327.734z M384.917,326.973l-13.615-0.594l2.159,12.405l13.645,0.596L384.917,326.973L384.917,326.973z M363.983,326.059l-16.203-0.707 c-0.987,0.254-2.093,0.461-3.3,0.652l-0.141-0.803l-13.227-0.577l2.188,12.407l12.787,0.558l-0.271-1.539l2.334-0.412l1.5,2.107
		l14.708,0.643l-5.338-6.855C360.42,329.856,362.467,328.349,363.983,326.059L363.983,326.059z M319.307,324.108l-13.454-0.588 l2.151,12.406l13.49,0.589L319.307,324.108L319.307,324.108z M297.326,323.148l-1.166-0.051l0.043,0.263L297.326,323.148 L297.326,323.148z M294.016,323.004l-25.159-1.099c-1.853,2.864-2.52,6.458-1.782,10.636c0.096,0.568,0.215,1.104,0.352,1.614 l25.026,1.093c-5.751-2.267-12.186-1.955-12.837-6.012c-0.903-5.746,7.992-7.423,15.047-2.762L294.016,323.004L294.016,323.004z M433.067,241.61l3.166-11.745l-13.048,2.301l-1.588,7.969C425.375,240.551,429.207,241.035,433.067,241.61L433.067,241.61z M412.546,239.25l-3.344-4.507l-17.765,3.052l9.128,0.559C404.441,238.606,408.447,238.896,412.546,239.25L412.546,239.25z"
    />






    

		</svg>
		</div>

	);//return
}